export * from './instagram-feed/actionTypes';
export * from './shop/actionTypes';
export const SET_WIDGET_SETTINGS = 'SET_WIDGET_SETTINGS';
